export default {
  computed: {
    transactions () {
      return this.$store.getters['TransactionsStore/transactions'].filter(el => {
        if (el.budget && el.budget.type) {
          return el.budget && el.budget.type.code !== 'FLEXIBLE_REMUNERATION'
        } else {
          return el
        }
      })
    },
    users () {
      return this.$store.getters['TransactionsStore/users']
    },
    rows () {
      if (this.$route.meta.users) {
        return this.users
      }
      return this.transactions
    },
    currentPage () {
      return !this.$route.meta.users ? this.$store.getters['TransactionsStore/currentPage'] : this.$store.getters['TransactionsStore/usersCurrentPage']
    },
    lastPage () {
      return !this.$route.meta.users ? this.$store.getters['TransactionsStore/lastPage'] : this.$store.getters['TransactionsStore/usersLastPage']
    },
    isLoadingTransactions () {
      return this.$store.getters['TransactionsStore/isLoadingTransactions']
    },
    currentFilters () {
      return this.$store.getters['TransactionsStore/filters'] || false
    },
    currentReviewStatusFilter () {
      if (this.currentFilters) {
        return this.currentFilters['reviewStatus.code']
      }
      return false
    }

  },
  methods: {
    async nextPage () {
      if (this.$route.meta.users) {
        await this.$store.dispatch('TransactionsStore/nextUserReimbursementsPage')
      } else {
        await this.$store.dispatch('TransactionsStore/nextTransactionsPage')
        if (this.selectedTransactionsBulkAction) {
          this.$store.dispatch('TransactionsStore/setAllTransactionsAsSelected', { isExportTable: this.isExportTable })
        }
      }
    }
  }
}
